module.exports = __webpack_public_path__ + "static/media/mr.cb629791.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mr.svg
// module id = 1303
// module chunks = 0